module.exports = {
    COMPONENT: 'Component',
    NETWORK: 'Network',
    CONTAINER: 'Container',
    SITE: 'Site',
};
